import './Purchasedproduct.css'

import StarIcon from '@material-ui/icons/Star'
import HalfStar from '@material-ui/icons/StarHalf'


export default function Purchasedproduct({id,image,title,reviews,price}){


    return(
       <div className='purchased_product_main'>
            <div className='purchased__product'>
            <div className='purchased_product_list'>
                <div className='purchased_product_image'>
                    <img src={image}/>
                </div>
                <div className='purchased_product_details'>
                    <span className='purchased_product_title'>{title}</span>
                    <div className='purchased_product_icons'>
                        <StarIcon className='purchased_product_startIcon'/>
                        <StarIcon className='purchased_product_startIcon'/>
                        <StarIcon className='purchased_product_startIcon'/>
                        <StarIcon className='purchased_product_startIcon'/>
                        <HalfStar className='purchased_product_startIcon'/>
                        <span className='purchased_product_review'>{reviews}</span>
                    </div>
                    <div className='purchased_product_amount'>
                        
                        <span className='purchased_product_inr'>INR</span>
                        <span className='purchased_product_prize'>{price}</span>
                    </div>
                </div>
            </div>
            <hr></hr>
        </div>
       </div>
    );
}